import { Button, IconButton, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import WushSortableTable from "../../components/layout/WushSortableTable";
import { Delete, Edit, Search } from "@mui/icons-material";
import WushPopover from "../../components/layout/WushPopover";
import { useNavigate } from "react-router-dom";
import ItemCategoryName from "../../components/text/ItemCategoryName";
import DeleteConfirmation from "../../components/form/DeleteConfirmation";
import index from "../../api/auth/storePages";
import destroy from "../../api/auth/storePages/destroy";
import useStorePageStore from "../../stores/useStorePageStore";
import create from "../../api/auth/storePages/create";
import StorePageForm from "../../components/form/storePages/StorePageForm";

export default function StorePages() {
  const { storePages, setStorePages, removeStorePage, addStorePage } = useStorePageStore();

  useEffect(() => {
    index((response) => {
      setStorePages(response);
    });
  }, []);

  const navigate = useNavigate();

  const handleDelete = (itemCategory) => {
    destroy(itemCategory.id, () => {
      removeStorePage(itemCategory);
    });
  };

  const handleCreate = () => {
    create({ test: 'value' }, (response) => {
      addStorePage(response);
      navigate(`/store_pages/${response.id}`);
    });
  };

  return (
    <Stack>
      <Stack mb={2}>
        <Typography variant="h4">
          Store Pages
        </Typography>
        <Typography variant="body1">
          Manage store pages where you can offer items for sale or rent to your customers.
        </Typography>
      </Stack>
      <Stack mb={2} direction="row">
        <Button onClick={handleCreate} variant="contained" color="primary">
          Add Store Page
        </Button>
      </Stack>
      <Stack>
        <WushSortableTable
          headers={[
            {
              id: 1,
              key: "id",
              label: "ID"
            },
            {
              id: 2,
              key: "name",
              label: "Name"
            },
            {
              id: 2,
              label: "Category",
              customValue: (row) => <ItemCategoryName itemCategory={row.item_category} />
            },
            {
              id: 3,
              key: "published",
              customValue: (row) => row.published ? "Yes" : "No",
              label: "Published"
            },
            {
              id: 4,
              key: "actions",
              label: "Actions",
              customValue: (row) => console.log(row) || (
                <Stack direction="row">
                  <WushPopover
                    anchor={
                      <IconButton>
                        <Edit />
                      </IconButton>
                    }
                  >
                    <Stack
                      p={2}
                    >
                      <StorePageForm storePage={row} />
                    </Stack>
                  </WushPopover>
                  <IconButton onClick={() => navigate(`/store_pages/${row.id}`)}>
                    <Search />
                  </IconButton>
                  {row.deletable && <DeleteConfirmation handleDelete={() => handleDelete(row)}>
                    <IconButton>
                      <Delete />
                    </IconButton>
                  </DeleteConfirmation>}
                </Stack>
              )
            }
          ]}
          data={storePages}
        />
      </Stack>
    </Stack>
  );
}